import type { ReactNode } from 'react';
import { downloadSheet } from '../../components/report-grid/export';
import type { ExportSheet } from '../../components/report-grid/export';
import { useI18n } from '../../i18n/I18nProvider';
import './reports.css';

export interface ReportFrameProps<Row> {
  title: string;
  subtitle?: string;
  periodLabel: string;
  sheet: ExportSheet<Row>;
  actions?: ReactNode;
  children: ReactNode;
}

/** The shared report chrome: title, period, export buttons and the body. */
export function ReportFrame<Row>({
  title,
  subtitle,
  periodLabel,
  sheet,
  actions,
  children,
}: ReportFrameProps<Row>): JSX.Element {
  const { t } = useI18n();
  return (
    <section className="report">
      <header className="page-head report__head">
        <div>
          <h1>{title}</h1>
          {subtitle === undefined ? null : <p className="muted">{subtitle}</p>}
        </div>
        <div className="report__actions">
          <span className="report__period" data-testid="report-period">
            {periodLabel}
          </span>
          {actions}
          <button
            type="button"
            className="btn btn--ghost"
            data-testid="export-csv"
            onClick={() => downloadSheet(sheet, 'csv')}
          >
            {t('reportsExportCsv')}
          </button>
          <button
            type="button"
            className="btn btn--ghost"
            data-testid="export-xlsx"
            onClick={() => downloadSheet(sheet, 'xlsx')}
          >
            {t('reportsExportXlsx')}
          </button>
        </div>
      </header>
      {children}
    </section>
  );
}
